import { defineRecipe } from '@chakra-ui/react';

export const durationInputRecipe = defineRecipe({
  className: 'duration-input',
  base: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'neutral.800',
    border: '2px solid',
    borderColor: 'neutral.black',
    paddingX: 2,
    gap: 2,
    width: '100%',
    height: '100%',
    _hover: {
      borderColor: 'skyBlue',
    },
    _focusWithin: {
      borderColor: 'skyBlue',
    },
  },
});
